export default "__VITE_ASSET__C0Cj3OZo__"